import styled from 'styled-components';
import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

export const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${rem(spacing.base * 0.5)};
  height: ${rem(spacing.base * 4)};
  padding: 0 ${rem(spacing.base)};
  background-color: ${toColorString(color.base.snowWhite)};
  border: 1px solid ${toColorString(color.opacity.charcoal15)};
  border-radius: 2px;
  color: ${toColorString(color.base.charcoal)};
  cursor: pointer;
  font: inherit;
  text-align: left;
  white-space: nowrap;
  min-width: ${rem(280)};
`;

export const PopoverContent = styled.div`
  background-color: ${toColorString(color.base.snowWhite)};
  display: flex;
  flex-direction: column;
`;

export const HourRow = styled.div`
  display: flex;
  align-items: center;
  padding: ${rem(spacing.base)};
  border-top: 1px solid ${toColorString(color.opacity.charcoal15)};
`;

export const ButtonsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(spacing.base * 0.5)};
  padding: ${rem(spacing.base)};
  border-top: 1px solid ${toColorString(color.opacity.charcoal15)};
`;
